module.exports = "<header>\n  \n</header>\n<router-outlet (activate)=\"onActivate()\"></router-outlet>\n<footer #footer>\n</footer>\n<cookie-warner *ngIf=\"!novelia\"></cookie-warner>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main